<template>
    <div class="electrictiy-bill-calculator__result-table-container" v-if="calculatedPrice.total">
        <table class="electrictiy-bill-calculator__result-table" id="resultTable">
            <tbody>
                <tr v-if="store.showEffectCostInResult">
                    <td><div :style="{backgroundColor: colors.EffectCost.backgroundColor}"></div></td>
                    <td>{{ appSettings.EffectCostText }}</td>
                    <td aria-live="polite">{{getFormatedPrice(calculatedPrice.total.EffectCost)}}</td>
                </tr>
                <tr>
                    <td><div :style="{backgroundColor: colors.TransferCost.backgroundColor}"></div></td>
                    <td>{{ appSettings.TransferCostText }}</td>
                    <td aria-live="polite">{{getFormatedPrice(calculatedPrice.total.TransferCost)}}</td>
                </tr>                
                <tr>
                    <td><div :style="{backgroundColor: colors.EnergyTaxCost.backgroundColor}"></div></td>
                    <td>{{ appSettings.EnergyTaxCostText }}</td>
                    <td aria-live="polite">{{getFormatedPrice(calculatedPrice.total.EnergyTaxCost)}}</td>
                </tr>                
                <tr>
                    <td><div :style="{backgroundColor: colors.FixedCharge.backgroundColor}"></div></td>
                    <td>{{ appSettings.FixedChargeText }}</td>
                    <td aria-live="polite">{{getFormatedPrice(calculatedPrice.total.FixedCharge)}}</td>
                </tr>                
                <tr>
                    <td></td>
                    <td>Totalt</td>
                    <td aria-live="polite">{{getFormatedPrice(calculatedPrice.total.TotalCost)}}</td>
                </tr>                    
            </tbody>             
        </table>
    </div>
</template>


<script setup>
    import { useWizardStore } from '../stores/WizardStore';
    import { storeToRefs } from "pinia";
    import util from '../util'
    
    const store = useWizardStore()
    const { appSettings, calculatedPrice } = storeToRefs(store);

    const props = defineProps({
        colors: { type: Object, required: true },
    });    

    const getFormatedPrice = (price) => {
        return util.getFormatedPrice(price, 0);
    }
   
</script>



<style scoped>

</style>
